import { render, staticRenderFns } from "./ActiveUser.vue?vue&type=template&id=2cb43a69"
import script from "./ActiveUser.vue?vue&type=script&lang=js"
export * from "./ActiveUser.vue?vue&type=script&lang=js"
import style0 from "./ActiveUser.vue?vue&type=style&index=0&id=2cb43a69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports